// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"eR","imgTextCardBox":"eR","text-box":"eS","textBox":"eS","remark-val":"eT","remarkVal":"eT"};